import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const UPLOAD_BENEFICIARIES_REQUEST = "UPLOAD_BENEFICIARIES_REQUEST";
export const UPLOAD_BENEFICIARIES_SUCCESS = "UPLOAD_BENEFICIARIES_SUCCESS";
export const UPLOAD_BENEFICIARIES_FAILURE = "UPLOAD_BENEFICIARIES_FAILURE";

export const FETCH_BENEFICIARIES_REQUEST = "FETCH_BENEFICIARIES_REQUEST";
export const FETCH_BENEFICIARIES_SUCCESS = "FETCH_BENEFICIARIES_SUCCESS";
export const FETCH_BENEFICIARIES_FAILURE = "FETCH_BENEFICIARIES_FAILURE";

export const DOWNLOAD_TEMPLATE_REQUEST = "DOWNLOAD_TEMPLATE_REQUEST";
export const DOWNLOAD_TEMPLATE_SUCCESS = "DOWNLOAD_TEMPLATE_SUCCESS";
export const DOWNLOAD_TEMPLATE_FAILURE = "DOWNLOAD_TEMPLATE_FAILURE";

export const SET_UPLOAD_PROGRESS = "SET_UPLOAD_PROGRESS";

// Upload Beneficiaries
export const uploadBeneficiaries = (formData) => async (dispatch) => {
  dispatch({ type: UPLOAD_BENEFICIARIES_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(
      `${BASE_URL}/v1/api/uploadBeneficiaries`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: token,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          dispatch({ type: SET_UPLOAD_PROGRESS, payload: percentCompleted });
        },
      },
    );

    if (response.data.meta.status) {
      dispatch({
        type: UPLOAD_BENEFICIARIES_SUCCESS,
        payload: response.data.data,
      });
      dispatch({ type: SET_UPLOAD_PROGRESS, payload: 0 });
      return response.data;
    } else {
      dispatch({ type: UPLOAD_BENEFICIARIES_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: UPLOAD_BENEFICIARIES_FAILURE });
    dispatch({ type: SET_UPLOAD_PROGRESS, payload: 0 });
    throw error;
  }
};

export const fetchBeneficiaries =
  (page = 1, limit = 10, filters = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_BENEFICIARIES_REQUEST });

    const token = localStorage.getItem("token");

    try {
      let queryParams = `?page=${page}&limit=${limit}`;

      if (filters.district_id) {
        queryParams += `&district_id=${filters.district_id}`;
      }

      if (filters.municipality_id) {
        queryParams += `&municipality_id=${filters.municipality_id}`;
      }
      if (filters.ward_name) {
        queryParams += `&ward=${filters.ward_name}`;
      }

      if (filters.search) {
        queryParams += `&search=${encodeURIComponent(filters.search)}`;
      }
      if (
        filters.survey_completed !== undefined &&
        filters.survey_completed !== ""
      ) {
        queryParams += `&survey_completed=${filters.survey_completed}`;
      }

      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/beneficiaries${queryParams}`,
        {
          headers: { authorization: token },
        },
      );

      if (response.data.meta.status) {
        dispatch({
          type: FETCH_BENEFICIARIES_SUCCESS,
          payload: {
            data: response.data.data,
            pagination: response.data.meta.pagination,
            surveyStats: {
              totalSurvey: response.data.meta.pagination.totalSurvey || 0,
              surveyedCount: response.data.meta.pagination.surveyedCount || 0,
              pendingCount: response.data.meta.pagination.pendingCount || 0,
            },
          },
        });
        return response.data;
      } else {
        dispatch({ type: FETCH_BENEFICIARIES_FAILURE });
        throw new Error(response.data.meta.message);
      }
    } catch (error) {
      dispatch({ type: FETCH_BENEFICIARIES_FAILURE });
      toast.error(
        error.response?.data?.meta?.message || "Failed to fetch beneficiaries",
      );
      throw error;
    }
  };

//for bulk export
export const fetchAllBeneficiaries = async (filters = {}, limit = 200000) => {
  const token = localStorage.getItem("token");

  let queryParams = `?page=1&limit=${limit}`;

  if (filters.district_id) {
    queryParams += `&district_id=${filters.district_id}`;
  }

  if (filters.municipality_id) {
    queryParams += `&municipality_id=${filters.municipality_id}`;
  }
  if (filters.ward_name) {
    queryParams += `&ward=${filters.ward_name}`;
  }

  if (filters.search) {
    queryParams += `&search=${encodeURIComponent(filters.search)}`;
  }

  if (
    filters.survey_completed !== undefined &&
    filters.survey_completed !== ""
  ) {
    queryParams += `&survey_completed=${filters.survey_completed}`;
  }

  const response = await axios.get(
    `${BASE_URL}/v1/api/admin/beneficiaries${queryParams}`,
    {
      headers: {
        authorization: token,
      },
    },
  );

  return response.data.data;
};

// Download Template - Direct download from S3 URL using window.open
export const downloadTemplate = () => async (dispatch) => {
  dispatch({ type: DOWNLOAD_TEMPLATE_REQUEST });

  try {
    // Directly open the S3 URL - this will trigger download
    const s3Url =
      "https://e-attendance-ebs.s3.ap-south-1.amazonaws.com/uploads/e39bbf43-6eea-4429-968b-3f07273d82a5";

    // Open in new tab/window
    window.open(s3Url, "_blank");

    dispatch({ type: DOWNLOAD_TEMPLATE_SUCCESS });
    toast.success("Template downloading...");
  } catch (error) {
    dispatch({ type: DOWNLOAD_TEMPLATE_FAILURE });
    toast.error("Failed to download template. Please try again.");
    throw error;
  }
};
